var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageBmjRewardPoints(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:flight-roster"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 10.125C16.4477 10.125 16 9.67728 16 9.125V4.625C16 4.07272 15.5523 3.625 15 3.625H5.625C5.07272 3.625 4.625 4.07272 4.625 4.625V25.375C4.625 25.9273 5.07272 26.375 5.625 26.375H24V28H4C3.44772 28 3 27.5523 3 27V3C3 2.44772 3.44772 2 4 2H16.7411C17.0063 2 17.2606 2.10536 17.4482 2.29289L23.8321 8.67683C24.0196 8.86437 24.125 9.11872 24.125 9.38394V27.1875C24.125 27.6362 23.7612 28 23.3125 28V28C22.8638 28 22.5 27.6362 22.5 27.1875V11.125C22.5 10.5727 22.0523 10.125 21.5 10.125H17ZM17.625 7.5C17.625 8.05228 18.0727 8.5 18.625 8.5H18.9305C19.8214 8.5 20.2676 7.42286 19.6376 6.79289L19.3321 6.48738C18.7021 5.85742 17.625 6.30358 17.625 7.19449V7.5Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.562 15.575L13.2 12L14.825 15.575L18.4 17.2L14.825 18.838L13.2 22.4L11.562 18.838L8 17.2L11.562 15.575Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageBmjRewardPoints);
export default __webpack_public_path__ + "static/media/manage-bmj-reward-points.084be387819491d8fc4c1518ba992dc3.svg";
export { ForwardRef as ReactComponent };